import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import WalletList from './WalletList';

const Wallets = () => {
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const editRef = useRef(null);
  const [walletData, setWalletData] = useState({
    wallet_name: '',
    image: null,
    uuid: '',
    updated: false,
    editMode: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWalletData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileUpload = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      const formattedName = `image:${new Date()
        .toISOString()
        .replace(/[:-]/g, '')
        .replace(/\.\d{3}/, '')}.${file.name.split('.').pop()}`;

      setWalletData((prevState) => ({
        ...prevState,
        [field]: {
          file,
          formattedName,
        },
      }));
    }
  };

  const handleEditMode = (wallet) => {
    setWalletData({
      wallet_name: wallet.bank_name || '',
      image: wallet.logo ? { file: null, formattedName: wallet.logo } : null,
      uuid: wallet.uuid || '',
      updated: !walletData.updated,
      editMode: true,
    });
  };

  const cancelEdit = () => {
    setWalletData({
      wallet_name: '',
      image: null,
      uuid: '',
      updated: !walletData.updated,
      editMode: false,
    });
  };

  const confirmSubmit = (e) => {
    const { wallet_name } = walletData;
    confirmAlert({
      title: 'Are you sure you want to',
      message: walletData.editMode
        ? `update ${wallet_name}`
        : 'add a new wallet',
      buttons: [
        {
          label: 'Yes',
          onClick: () => submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const headers = authHeader(1);
    const url = `${process.env.API_URL}/utils/wallets/`;
    let method = 'POST';

    const formData = new FormData();
    formData.append('wallet_name', walletData.wallet_name);

    if (walletData.image?.file) {
      formData.append(
        'image',
        walletData.image.file,
        walletData.image.formattedName,
      );
    }

    if (walletData.editMode) {
      method = 'PUT';
      formData.append('uuid', walletData.uuid);
    }

    axios({
      method,
      url,
      data: formData,
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        toast.success('Wallet added successfully');
        window.scrollTo({
          behavior: 'smooth',
          top: editRef.current.offsetTop - 150,
        });
        setIsSubmitting(false);
        setWalletData({
          wallet_name: '',
          image: null,
          uuid: '',
          updated: !walletData.updated,
          editMode: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table" ref={editRef}>
        <header>
          <h3>Wallets</h3>
        </header>
        <main>
          <div className="form-content">
            <table>
              <thead>
                <tr>
                  <th>Wallet</th>
                  <th>Logo</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${walletData.editMode ? 'highlight-bg' : ''}`}>
                  <td>
                    <div className="input-wrapper">
                      <input
                        name="wallet_name"
                        type="text"
                        onChange={handleChange}
                        placeholder="Wallet Name"
                        value={walletData.wallet_name}
                        required
                      />
                    </div>
                  </td>
                  <td>
                    <div className="actions">
                      <div className="input-wrapper file-upload">
                        <div
                          className="input-group"
                          style={{ display: 'flex' }}
                        >
                          <input
                            type="file"
                            id="web-image-upload"
                            name="image"
                            onChange={(e) => handleFileUpload(e, 'image')}
                            accept=".png, .jpg, .jpeg"
                            placeholder="Upload Wallet Logo"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="form-actions">
              <button
                className="submit"
                type="submit"
                onClick={confirmSubmit}
                disabled={isSubmitting}
              >
                Submit
              </button>
              {walletData.editMode && (
                <button className="red-btn" onClick={cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        </main>
      </section>
      <WalletList key={walletData.updated} onEdit={handleEditMode} />
    </>
  );
};

export { Wallets };
